import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { CookieService  } from 'ngx-cookie-service';
import { Observable,BehaviorSubject, EMPTY, throwError } from 'rxjs';
import { map,catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class DirectoryService {

  constructor(private http: HttpClient, private router: Router, private cookieService: CookieService, private authService: AuthService) {}

  getLibraryList(keyword):  Observable<any> {
    let headers = new HttpHeaders({'Content-Type':'text/plain'});
    return this.http.get('https://surpasssupport.com/api/opacdirectory?name='+keyword,{ headers: headers, observe:'response' })
    .pipe(map((response: HttpResponse<any>) => {
      this.authService.setIdleTimer();
      return response.body;
    }),
      catchError((error) => this.handleError(error))
    );
  }
  public handleError(error: any) {
    console.log("error", error);
    if (error.status == 401) {
        this.authService.logoutSubject.next(true);
      return EMPTY;
    } else {
      return throwError(error);
    }
  }
}
